import { EmailsArchived } from '@Containers/Emails';

const ScriptsActivePage: React.FunctionComponent = (): JSX.Element => (
  <EmailsArchived />
);

export default ScriptsActivePage;
